import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function FeeStructure() {
  return (
    <>
      <Header />
      {/* Inner Slider */}
      <section class="inr-header">
        <div class="container">
          <div class="inr-header-content">
            <h1 class="title">Fee Structure</h1>
            <ul class="breadcrumb">
              <li><NavLink to="/">Home</NavLink></li>
              <li> Fee Structure</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  Inner Body */}
      <section className="innerBody">
        <div className="container  them-container">
          <div className="row">
            <div className="col-12">
              <h1>Fee Structure</h1>
              <iframe src="https://webapi.entab.info/api/image/SMNSB/public/pdf/FeesStructure.pdf#toolbar=0" width="100%" height="500"></iframe>
            </div>
          </div>
        </div>
      </section>
      <div className="clr100"></div>
      {/* Footer */}
      <Footer />
    </>
  )
}

export default FeeStructure